import { MenuItem } from "@mui/material";
import { Form } from "formik";
import * as yup from "yup";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledArtFormConfiguration } from "../../../styled/artFormConfiguration";


const validationSchema = yup.object().shape({
  art: yup.string().required("La ART es obligatoria"),
});

const ArtFormSearchForm = ({
  loading,
  arts,
  handleSubmitSearch,
  initialValues,
}) => {
  return (
    <div>
      <StyledArtFormConfiguration.StyledPaper>
        {!loading ? (
          <FormikForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values }) => (
              <Form>
                <StyledArtFormConfiguration.StyledInput>
                  <FormikSelect name="art" label="Art" variant="standard">
                    {arts.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledArtFormConfiguration.StyledInput>
                <StyledArtFormConfiguration.ButtonContainer>
                  <StyledArtFormConfiguration.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}>
                    Buscar
                  </StyledArtFormConfiguration.StyledButton>
                </StyledArtFormConfiguration.ButtonContainer>
              </Form>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledArtFormConfiguration.StyledPaper>
    </div>
  );
};

export default ArtFormSearchForm;